import { createStore, setStateHelper } from "@neonumy/ant-design";
import { StoreApi, UseBoundStore } from "zustand";

interface UserDataStore {
  userData: GetUserByToken;
  resetStore: () => void;
  setUserData: (userData: GetUserByToken) => void;
}

const useUserDataStore: UseBoundStore<StoreApi<UserDataStore>> = createStore<UserDataStore>(
  (set: (fn: (draft: UserDataStore) => void) => void) => ({
    userData: undefined,
    resetStore: () => {
      set(() => ({
        userData: undefined,
      }));
    },
    setUserData: (userData: GetUserByToken) => {
      setStateHelper("userData", userData, set);
    },
  }),
);

export default useUserDataStore;
